import { NgModule } from '@angular/core';
import { AsmRootModule } from '@spartacus/asm/root';

@NgModule({
  declarations: [],
  imports: [AsmRootModule],
  providers: [],
})
export class AsmFeatureModule {}
